import { TopToolbar, useListContext, usePermissions } from "react-admin";
import CustomExportButton from "../unit/CustomExportButton";
import CustomFilterButton from "../unit/CustomFilterButton";
const CustomerListActions = () => {
  const { total, filterValues, showFilter, hideFilter, displayedFilters } =
    useListContext();
  const filterFieldLength = Object.keys(displayedFilters).length;
  const { permissions } = usePermissions();
  return (
    <>
      <TopToolbar sx={{ width: "100%" }}>
        <CustomFilterButton />
        <CustomExportButton />
      </TopToolbar>
    </>
  );
};

export default CustomerListActions;
